import { useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'

import { useSearchPatientsQuery } from '@/core/services/patient'
import { PatientSourceEnum } from '@/core/enums/patient-source.enum'

import PatientsCard from '../components/PatientsCard'

export function PatientsCardContainer() {

  const [searchPatientsArgs, setSearchPatientsArgs] = useState({
    patientSource: PatientSourceEnum.MedconnectPatient,
    limit: 5,
    skip: 0,
    orderBy: 'userInfo.surname' as const,
  })

  const { patients, totalPatients } = useSearchPatientsQuery(searchPatientsArgs, {
    refetchOnMountOrArgChange: true,
    selectFromResult: ({ data, ...rest }) => ({
      ...rest,
      patients:
        data?.items.map((patient) => ({
          id: patient._id,
          name: patient.userInfo.name,
          surname: patient.userInfo.surname,
          gender: patient.userInfo.gender,
        })) ?? [],
      totalPatients: data?.totalCount ?? 0,
    }),
  })

  const onTextSearch = useDebouncedCallback((text: string) => {
    setSearchPatientsArgs((prevArgs) => ({ ...prevArgs, smartSearch: text || undefined, skip: 0 }))
  }, 300)

  return <PatientsCard disableShowMore={totalPatients <= 5} patients={patients} onTextSearch={onTextSearch} />
}

export default PatientsCardContainer
